"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../../store/amount/actions");
var actions_2 = require("../../store/challenges/actions");
var actions_3 = require("../../store/name/actions");
var ParentWindow = (function () {
    function ParentWindow() {
    }
    ParentWindow.listen = function (store) {
        var _this = this;
        var nameElement = document.getElementById('coinNameInput');
        window.addEventListener("message", function (event) {
            try {
                if (!_this.isJsonString(event)) {
                    if (JSON.parse(event.data).payload.action == 'customLogout') {
                        window['customLoggedIn'] = true;
                        window['customToken'] = '';
                        store.dispatch(actions_1.resetAmount());
                        store.dispatch(actions_2.resetChallenge());
                        store.dispatch(actions_3.setName({
                            name: ''
                        }));
                        nameElement.value = store.getState().name.name;
                        var amountElements = document.querySelectorAll('.ctrl-amount');
                        var challengeElems = document.querySelectorAll('.ctrl-no-of-chalenges');
                        Array.from(amountElements).forEach(function (element) {
                            if (element.classList.contains('active')) {
                                store.dispatch(actions_1.resetAmount());
                                element.classList.remove('active');
                            }
                        });
                        Array.from(challengeElems).forEach(function (element) {
                            if (element.classList.contains('active')) {
                                store.dispatch(actions_2.resetChallenge());
                                element.classList.remove('active');
                            }
                        });
                        document.getElementById('defaultChallenge').classList.add('active');
                        store.dispatch(actions_2.setChallenge({
                            nomber: 1
                        }));
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
        }, false);
    };
    ParentWindow.isJsonString = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    return ParentWindow;
}());
exports.default = ParentWindow;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/listeners/parent-window/parent-window.ts
// module id = 2422
// module chunks = 5